'use client';

import { c as _c } from "react/compiler-runtime";
import type { BrandConfig } from '@material-bank/mtag-graphql-schema';
import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
type ConfigViewModel = {
  tagRef: string;
  /** The tag's brand id. Empty when the tag query has not resolved yet. */
  brandId: string;
  /** The tag's Material Bank brand id (MBID). Empty until the tag query resolves. */
  brandRef: string;
  projectRef: string;
  productRef: string;
  brandConfig: BrandConfig;
};
type ConfigProviderProps = PropsWithChildren<{
  tagRef: string;
  brandId: string;
  brandRef: string;
  projectRef: string;
  productRef: string;
  brandConfig: BrandConfig;
}>;
const ConfigContext = createContext<ConfigViewModel | null>(null);
export function ConfigProvider(t0) {
  const $ = _c(10);
  const {
    tagRef,
    brandId,
    brandRef,
    projectRef,
    productRef,
    brandConfig,
    children
  } = t0;
  let t1;
  if ($[0] !== brandConfig || $[1] !== brandId || $[2] !== brandRef || $[3] !== productRef || $[4] !== projectRef || $[5] !== tagRef) {
    t1 = {
      tagRef,
      brandId,
      brandRef,
      projectRef,
      productRef,
      brandConfig
    };
    $[0] = brandConfig;
    $[1] = brandId;
    $[2] = brandRef;
    $[3] = productRef;
    $[4] = projectRef;
    $[5] = tagRef;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const value = t1;
  let t2;
  if ($[7] !== children || $[8] !== value) {
    t2 = <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
    $[7] = children;
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export function useConfigProvider() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfigProvider must be used within a ConfigProvider");
  }
  return context;
}

// Non-throwing variant for consumers that may render outside a tag context
// (e.g., dialogs mounted at the locale layout). Returns null when no
// ConfigProvider is in the React tree.
export function useConfigProviderSafe() {
  return useContext(ConfigContext);
}